function getGlobalTimer(name) {
  if (typeof window !== "undefined" && typeof window[name] === "function") {
    return window[name].bind(window);
  }
  return globalThis[name].bind(globalThis);
}

function scheduleIdlePreload(tasks, options = {}) {
  const win = options.window || (typeof window !== "undefined" ? window : null);
  const doc = options.document || (typeof document !== "undefined" ? document : null);
  const setTimer = options.setTimeout || getGlobalTimer("setTimeout");
  const clearTimer = options.clearTimeout || getGlobalTimer("clearTimeout");
  const delay = options.delay == null ? 1200 : options.delay;
  const stepDelay = options.stepDelay == null ? 180 : options.stepDelay;
  const idleTimeout = options.idleTimeout == null ? 2500 : options.idleTimeout;

  let cancelled = false;
  let loadHandler = null;
  let idleId = null;
  const timerIds = [];

  const addTimer = (callback, timeout) => {
    const timerId = setTimer(callback, timeout);
    timerIds.push(timerId);
    return timerId;
  };

  const runTask = (task) => {
    try {
      Promise.resolve(task()).catch(() => {});
    } catch (error) {
      // Preloading is opportunistic; a failed warmup must not break the page.
    }
  };

  const runNext = (index) => {
    if (cancelled || index >= tasks.length) {
      return;
    }
    addTimer(() => {
      if (cancelled) {
        return;
      }
      runTask(tasks[index]);
      runNext(index + 1);
    }, index === 0 ? 0 : stepDelay);
  };

  const startTasks = () => {
    if (cancelled) {
      return;
    }

    addTimer(() => {
      if (cancelled) {
        return;
      }

      if (win && typeof win.requestIdleCallback === "function") {
        idleId = win.requestIdleCallback(() => runNext(0), { timeout: idleTimeout });
        return;
      }

      runNext(0);
    }, delay);
  };

  if (doc && doc.readyState !== "complete" && win && typeof win.addEventListener === "function") {
    loadHandler = startTasks;
    win.addEventListener("load", loadHandler, { once: true });
  } else {
    startTasks();
  }

  return () => {
    cancelled = true;
    timerIds.forEach((timerId) => clearTimer(timerId));
    timerIds.length = 0;

    if (win && idleId !== null && typeof win.cancelIdleCallback === "function") {
      win.cancelIdleCallback(idleId);
    }

    if (win && loadHandler && typeof win.removeEventListener === "function") {
      win.removeEventListener("load", loadHandler);
    }
  };
}

function preloadImage(src) {
  if (!src || typeof Image === "undefined") {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = src;
  });
}

module.exports = {
  preloadImage,
  scheduleIdlePreload,
};
